import { Component, OnDestroy, AfterViewInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

declare var $: any;

@Component({
  selector: 'app-marcas',
  templateUrl: './marcas.component.html',
  styleUrls: ['./marcas.component.scss']
})
export class MarcasComponent implements AfterViewInit, OnDestroy {
  marcas: any[] = [];
  private sliderInstance: any;

  constructor(private http: HttpClient) { }

  ngAfterViewInit(): void {
    this.http.get(environment.configUrl).subscribe((res: any) => {
      this.marcas = res.marcas;
      // Retrasar inicialización del slider con retries
      //     this.waitForSliderItemsAndInit(2);
      setTimeout(() => this.waitForSliderItemsAndInit(), 0); // deja que Angular termine de pintar

    });
  }

  ngOnDestroy(): void {
    if (this.sliderInstance && typeof this.sliderInstance.flickity === 'function') {
      this.sliderInstance.flickity('destroy');
    }
  }

  private waitForSliderItemsAndInit(retry = 0): void {
    const MAX_RETRIES = 10;
    const RETRY_DELAY = 100; // ms

    setTimeout(() => {
      const $slider = $('.js-slider');
      const $items = $slider.find('.slider__item');

      if ($items.length > 0) {
        this.initSlider();
      } else if (retry < MAX_RETRIES) {
        this.waitForSliderItemsAndInit(retry + 1);
      } else {
        console.warn('⚠️ No se encontraron items para el slider luego de varios intentos.');
      }
    }, RETRY_DELAY);
  }

  private initSlider(): void {
    if (this.sliderInstance) {
      this.sliderInstance.flickity('destroy');
    }

    this.sliderInstance = $('.js-slider').flickity({
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      autoPlay: 2000,
      pauseAutoPlayOnHover: true,
      prevNextButtons: true,
      pageDots: false,
      draggable: true,
      groupCells: 2
    });
  }
}
